import React from 'react';
import { IconButton, Td } from '@chakra-ui/react';
import { localise } from '../../../services/lang/lang';
import Chevron, { ChevronDirection } from '../../icons/Chevron';
import { useTokens } from '../../../context/TokenProvider';
const TableExpandButton = ({ isExpanded }) => {
    const tokens = useTokens();
    return (React.createElement(Td, { w: "56px" },
        React.createElement(IconButton, { variant: "ghost", icon: React.createElement(Chevron, { fill: tokens.IconPrimary, direction: isExpanded ? ChevronDirection.DOWN : ChevronDirection.RIGHT }), "aria-label": localise('EXPAND_ROW') })));
};
export default TableExpandButton;
